import styled from "styled-components";

import { ListSectionTextItem, ListSectionTextItemIconContainer } from "uikit";

const logoSize = {
  row: {
    width: 125,
    height: 66,
  },
  column: {
    width: 97,
    height: 52,
  },
};

export const Container = styled.div`
  padding: 35px 53px 61px 53px;
  background-color: ${({ theme }) => theme.colors.contentBg};
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.primaryAlt4};
  background-repeat: no-repeat;
  background-position: bottom right;
`;

export const HeaderContainerRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const LogoContainerRowHeader = styled.div`
  width: ${logoSize.row.width}px;
  height: ${logoSize.row.height}px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const HeaderContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const LogoContainerColumnHeader = styled.div`
  width: ${logoSize.column.width}px;
  height: ${logoSize.column.height}px;
  margin-bottom: ${({ theme }) => theme.margin.m22};

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const BenefitsSection = styled.div`
  margin-bottom: ${({ theme }) => theme.margin.m16};
`;

export const BenefitsListItem = styled(ListSectionTextItem)`
  display: flex;
  align-items: baseline;
  margin-bottom: ${({ theme }) => theme.margin.m12};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledListTextItemIconContainer = styled(ListSectionTextItemIconContainer)`
  font-size: ${({ theme }) => theme.size.subtitleLarge};
  width: auto;
  line-height: 1;
`;
